import createReducer from "Common/reducerUtils/createReducer";
import set from "Common/reducerUtils/set";
import keyBy from "lodash/keyBy";
import actionTypes from "./actionTypes";
import { buildReduxAccessLevelKey } from "./selectors";
export const initialState = {
    data: {},
    isOpen: undefined
};
export default createReducer(initialState, {
    [actionTypes.GET_ACCESS_LEVELS_COMPLETED]: (state, { payload }) => set(state, `data[${buildReduxAccessLevelKey(payload.EntityId, payload.EntityType)}]`, keyBy(payload.Permissions, "UserId")),
    [actionTypes.SET_IS_OPEN]: (state, { isOpen }) => ({
        ...state,
        isOpen
    })
});
